import React from 'react';
import styled, { keyframes } from 'styled-components';
import { FaWhatsapp } from 'react-icons/fa';

const WhatsAppButton = () => {
  return (
    <WhatsAppLink
      href="https://wa.me/254757504508"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with us on WhatsApp"
    >
      <WhatsAppIcon>
        <FaWhatsapp />
      </WhatsAppIcon>
      <ButtonTooltip>Chat with us</ButtonTooltip>
    </WhatsAppLink>
  );
};

const pulse = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(37, 211, 102, 0.5);
  }
  70% {
    box-shadow: 0 0 0 15px rgba(37, 211, 102, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(37, 211, 102, 0);
  }
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const WhatsAppLink = styled.a`
  position: fixed;
  bottom: 30px;
  right: 30px;
  z-index: 999;
  display: flex;
  align-items: center;
  text-decoration: none;
  
  &:hover {
    div:last-child {
      opacity: 1;
      visibility: visible;
      transform: translateX(0);
    }
  }
  
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    bottom: 20px;
    right: 20px;
  }
`;

const WhatsAppIcon = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: #25D366;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  animation: ${pulse} 2s infinite;
  transition: all 0.3s ease;
  
  svg {
    color: white;
    font-size: 30px;
  }
  
  &:hover {
    transform: scale(1.05);
    background-color: #20c35f;
  }
  
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    width: 50px;
    height: 50px;
    
    svg {
      font-size: 25px;
    }
  }
`;

const ButtonTooltip = styled.div`
  background-color: #333;
  color: white;
  padding: 8px 15px;
  border-radius: 5px;
  margin-right: 15px;
  opacity: 0;
  visibility: hidden;
  transform: translateX(10px);
  transition: all 0.3s ease;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  font-weight: 500;
  font-size: 14px;
  animation: ${fadeIn} 0.3s forwards;
  
  &:after {
    content: "";
    position: absolute;
    top: 50%;
    right: -8px;
    transform: translateY(-50%);
    border-width: 8px 0 8px 8px;
    border-style: solid;
    border-color: transparent transparent transparent #333;
  }
`;

export default WhatsAppButton;